// TODO 试验性代码
import FJLocalStore from '../../../store/FJLocalStore.js';

class FJTipsHeader {
    constructor(props) {
        this._image = props.image;
        this._text = props.text;
    }

    render(options = {}) {
        const { className } = options;
        return (
            <div className={className}>
                {this._image}
                {FJLocalStore._(this._text)}
            </div>
        );
    }
}

export default FJTipsHeader;
